import {Component, OnInit, Injector, AfterViewInit, Input, OnDestroy} from '@angular/core';
import {AppComponentBase} from '../../../../services/AppComponentBase';
import {ScannerSide, ScannerChartingStudy} from '../../interfaces/scanner.enums';
import {IRSIScanRule, chartingSaved} from '../../interfaces/scanner.interfaces';
import {Options} from 'ng5-slider';


@Component({
    selector: 'app-scanner-RSISelector',
    template: require('./scanner-RSISelector.component.html'),
    styles: [require('./scanner-RSISelector.component.scss')]
})
export class ScannerRSISelectorComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {



    public _narrowScannerMode: boolean = false;

    @Input() public set narrowScannerMode(value: boolean) {
        this._narrowScannerMode = value

        if(value == true) {
            this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.rsiPeriod, priceline: this.oversoldValue};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }


    }

    public get narrowScannerMode() {
        return this._narrowScannerMode;
    }








    ngAfterViewInit(): void {
        let v = this.workspace.initLoadScan;
        if(v != null) {
            this.loadScanData(v);
            this.workspace.initLoadScan = null;
        }
    }

    public loadScanData(v: any) {
        let loadScanData: chartingSaved = (!this.narrowScannerMode) ? <chartingSaved> v.savedData : <chartingSaved> v.savedDataSecondary;
        console.log(v);
        this.workspace.scannerSearch_period = loadScanData.period;

        let scanRule: IRSIScanRule = <IRSIScanRule> loadScanData.rule;

        this.workspace.scannerSearch_side = scanRule.direction;
        //this.deviation = scanRule.deviation;
        this.rsiPeriod = scanRule.period;
        if(scanRule.priceline >= 60) {
            this.overboughtValue = scanRule.priceline;
            this.overbought = true;
        }

        if(scanRule.priceline <= 40) {
            this.oversoldValue = scanRule.priceline;
            this.oversold = true;
        }

        this.enableAdvancedSetup = true;
        this.workspace.canSelectedSavedScanUpdate = false;
        this.workspace.allowScanProcess = true;
    }



    constructor(injector: Injector) {
        super(injector);

        if(this.workspace.isNarrowScanMode) {
            this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.rsiPeriod, priceline: this.oversoldValue};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }

        if(!this.workspace.isNarrowScanMode) {
            this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.rsiPeriod, priceline: this.oversoldValue};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }


        this.workspace.globaGridMode.changeScannerSide.subscribe(v => {
            if(!this.narrowScannerMode) {
                if(this.workspace.scannerSearch_chartingstudy == ScannerChartingStudy.SCANNER_RSI) {
                    if(v == ScannerSide.SCANNER_SIDE_SELL) {
                        this.overbought = true;
                        this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
                    }
                    if(v == ScannerSide.SCANNER_SIDE_BUY) {
                        this.oversold = true;
                        this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
                    }
                }
            }
        })


        this.workspace.globaGridMode.changeScannerNarrowSide.subscribe(v => {
            if(this.narrowScannerMode) {
                if(this.workspace.scannerSearch_Narrow_chartingstudy == ScannerChartingStudy.SCANNER_RSI) {
                    if(v == ScannerSide.SCANNER_SIDE_SELL) {
                        this.overbought = true;
                        this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
                    }
                    if(v == ScannerSide.SCANNER_SIDE_BUY) {
                        this.oversold = true;
                        this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
                    }
                }
            }
        })







        this.workspace.globaGridMode.loadScannerRule.subscribe(v => {

            if(v.study == ScannerChartingStudy.SCANNER_RSI)
                this.loadScanData(v)

        });

    }

    public loaderSubscribed: boolean = false;
    public subscribers: any = {};
    ngOnDestroy() {
        // this.subscribers.load.unsubscribe();
    }







    //value: number = 5;

    private _rsiPeriod: number = 14;
    public get rsiPeriod(): number {
        return this._rsiPeriod;
    }
    public set rsiPeriod(value: number) {
        this._rsiPeriod = value < 1 ? 1 : value;


        if(!this.narrowScannerMode) {
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: value, priceline: this.oversoldValue};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: value, priceline: this.oversoldValue};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    public get isRsPeriodValid() {
        return !isNaN(Number(this.rsiPeriod))
    }

    private _enableAdvancedSetup: boolean = false;
    public get enableAdvancedSetup(): boolean {
        return this._enableAdvancedSetup;
    }
    public set enableAdvancedSetup(value: boolean) {
        this._enableAdvancedSetup = value;
    }

    public get isBandSelectedValid() {
        return this.overbought || this.oversold;
    }


    private _overbought: boolean = false;
    public get overbought(): boolean {
        return this._overbought;
    }
    public set overbought(value: boolean) {
        this._oversold = !value;
        this._overbought = value;
        if(value == true) {

            if(!this.narrowScannerMode) {
                this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_SELL;
                this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.rsiPeriod, priceline: this.overboughtValue};
            }
            else {
                if(this.workspace.usePrimarySide) {
                    return
                }
                this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_SELL;
                this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.rsiPeriod, priceline: this.overboughtValue};
            }
            this.oversold = false;
        }

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }


    }


    private _oversold: boolean = true;
    public get oversold(): boolean {
        return this._oversold;
    }
    public set oversold(value: boolean) {
        this._oversold = value;
        this._overbought = !value;
        if(value == true) {

            if(!this.narrowScannerMode) {

                this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
                this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.rsiPeriod, priceline: this.oversoldValue};
            }
            else {
                if(this.workspace.usePrimarySide) {
                    return
                }
                this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
                this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.rsiPeriod, priceline: this.oversoldValue};
            }

            this.overbought = false;
        }

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }



    }


    public overboughtAction() {
        this.overbought = !this.overbought
    }

    public oversoldAction() {
        this.oversold = !this.oversold
    }

    private _overboughtValue: number = 70;
    public get overboughtValue(): number {
        return this._overboughtValue;
    }
    public set overboughtValue(value: number) {
        this._overboughtValue = value;
        if(!this.narrowScannerMode) {
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.rsiPeriod, priceline: value};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.rsiPeriod, priceline: value};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    private _oversoldValue: number = 30;
    public get oversoldValue(): number {
        return this._oversoldValue;
    }
    public set oversoldValue(value: number) {
        this._oversoldValue = value;
        if(!this.narrowScannerMode) {
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.rsiPeriod, priceline: value};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.rsiPeriod, priceline: value};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }



    overBounghtoptions: Options = {
        showTicksValues: true,
        stepsArray: [
            {value: 60},
            {value: 61},
            {value: 62},
            {value: 63},
            {value: 64},
            {value: 65},
            {value: 66},
            {value: 67},
            {value: 68},
            {value: 69},
            {value: 70},
        ]
    };

    overSoldoptions: Options = {
        showTicksValues: true,
        stepsArray: [
            {value: 30},
            {value: 31},
            {value: 32},
            {value: 33},
            {value: 34},
            {value: 35},
            {value: 36},
            {value: 37},
            {value: 38},
            {value: 39},
            {value: 40},
        ]
    };







    ngOnInit() {
    }
    public scanRule: IRSIScanRule = {direction: this.workspace.scannerSearch_side, period: this.rsiPeriod, priceline: this.oversoldValue}


}

